import { render, staticRenderFns } from "./PdHero.vue?vue&type=template&id=16c8616e&scoped=true&"
import script from "./PdHero.vue?vue&type=script&lang=js&"
export * from "./PdHero.vue?vue&type=script&lang=js&"
import style0 from "./PdHero.vue?vue&type=style&index=0&id=16c8616e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8616e",
  null
  
)

export default component.exports